import { appshellMenuExtensionSlots } from '@sharefiledev/appshell-menu-pilet-sdk';
import { Cog } from '@sharefiledev/icons';
import type { PiletApi } from '@sharefiledev/sharefile-appshell';
import { AsyncLazyUserMenu } from './extensions';
import { setLogger } from './logger';

export function setup(piletApi: PiletApi) {
	setLogger(piletApi.sf.getLogger());

	piletApi.registerExtension(appshellMenuExtensionSlots.userMenu, () => (
		<AsyncLazyUserMenu piletApi={piletApi} />
	));

	if (process.env.NODE_ENV === 'development') {
		piletApi.registerPage('/user-menu-development', () => (
			<AsyncLazyUserMenu piletApi={piletApi} />
		));

		piletApi.sf.registerLeftNavComponent({
			href: '/user-menu-development',
			title: () => 'User Menu Dev',
			icon: Cog,
			weight: 100,
		});
	}
}
